import { drivers } from '../config';
export = drivers.sqlite3;
